import { getMomentTz } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";

import ReactECharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import { useEffect, useRef } from "react";
import { useCastersContext } from "../../../CastersContext";
import { useTableStyles } from "../../../styles/useTableStyles";
import { useChartStyles } from "../styles/useChartStyles";
import { useChartOptions } from "./hooks/useChartOptions";

const moment = getMomentTz();
export const BilletTempChart = () => {
	const {
		state: { billetTemp, processData },
	} = useCastersContext();
	const classes = useTableStyles();
	const chartClasses = useChartStyles();
	const echartsRef = useRef<ReactEChartsCore>(null);

	const chartOptions = useChartOptions({ billetTemp, processData });

	useEffect(() => {
		if (echartsRef.current) {
			const instance = echartsRef.current.getEchartsInstance();
			instance.setOption(chartOptions, {
				replaceMerge: ["series"],
				lazyUpdate: true,
			});
		}
	}, [chartOptions]);

	return (
		<Paper className={classes.borderAgGridTable} elevation={0}>
			<Box p={0}>
				<div className={classes.materialTable}>
					<div className={chartClasses.chartHeader}>Billet Temperature</div>
					<ReactECharts
						ref={echartsRef}
						option={chartOptions}
						notMerge={false}
					/>
				</div>
			</Box>
		</Paper>
	);
};
